(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-home-colors"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pu-colors').forEach((section) => {
    const preview = section.querySelector('[data-pu-preview-swatch]');
    const previewName = section.querySelector('[data-pu-preview-name]');
    const ctaName = section.querySelector('[data-pu-preview-cta-name]');
    const swatches = section.querySelectorAll('.pu-color-swatch');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const { puColorName: name, puColorHex: hex } = swatch.dataset;

        swatches.forEach((other) => {
          other.classList.toggle('is-selected', other === swatch);
          other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
        });

        if (preview) preview.style.background = hex;
        if (previewName) previewName.textContent = name;
        if (ctaName) ctaName.textContent = name;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
